<div class="py-1" role="none">
    <ng-container *ngIf="source === 'invoice'">
    <a *ngIf="!invoice.status || invoice.status !== 'pending'" href="javascript:void(0)" (click)="download.emit(invoice)"
        class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
        role="menuitem" tabindex="-1" id="menu-item-0">
        <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 h-5 w-5 text-main-primary"
            viewBox="0 0 24 24"><!-- Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
            <path fill="currentColor" d="M4 22v-2h16v2zm8-4L5 9h4V2h6v7h4z" />
        </svg>
        Download
    </a>
    <a href="javascript:void(0)" (click)="delete.emit(invoice)"
        class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
        role="menuitem" tabindex="-1" id="menu-item-0">
        <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 h-5 w-5 text-main-primary"
            viewBox="0 0 24 24"><!-- Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
            <path fill="currentColor"
                d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2zM7 6v13z" />
        </svg>
        Delete
    </a>
    <a *ngIf="!invoice.status || invoice.status !== 'pending'" href="javascript:void(0)" (click)="send.emit(invoice)"
        class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
        role="menuitem" tabindex="-1" id="menu-item-0">
        <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 h-5 w-5 text-main-primary"
            viewBox="0 0 24 24"><!-- Icon from Remix Icon by Remix Design - https://github.com/Remix-Design/RemixIcon/blob/master/License -->
            <path fill="currentColor"
                d="M1.946 9.315c-.522-.174-.527-.455.01-.634L21.044 2.32c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8l-8 6z" />
        </svg>
        Send
    </a>
    <a *ngIf="invoice?.canReceivePayment" href="javascript:void(0)" (click)="receivePayment.emit(invoice)"
        class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
        role="menuitem" tabindex="-1" id="menu-item-0">
        <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 h-5 w-5 text-main-primary" fill="none" viewBox="0 0 24 24"
            stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
                d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
        </svg>
        Receive Payment
    </a>
    <a href="javascript:void(0)" (click)="detail.emit(invoice)"
        class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
        role="menuitem" tabindex="-1" id="menu-item-0">
        <svg class="mr-3 h-5 w-5 text-main-primary" fill="currentColor" viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M12 15a3 3 0 100-6 3 3 0 000 6z"></path>
            <path clip-rule="evenodd" d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 
                                                                        3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 
                                                                        4.471-5.705 7.697-10.677 7.697-4.97 
                                                                        0-9.186-3.223-10.675-7.69a1.762 
                                                                        1.762 0 010-1.113zM17.25 12a5.25 
                                                                        5.25 0 11-10.5 0 5.25 5.25 0 
                                                                        0110.5 0z" fill-rule="evenodd">
            </path>
        </svg>
        Detail
    </a>
    <a *ngIf="invoice.status !== 'pending'" href="javascript:void(0)" (click)="pullFrom.emit(invoice)"
        class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
        role="menuitem" tabindex="-1" id="menu-item-0">
        <svg [ngClass]="{'animate-spin': invoice.pulling}" class="mr-3 h-5 w-5 text-main-primary"
            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
        </svg>
        Pull From
    </a>
    <a href="javascript:void(0)" (click)="pushTo.emit(invoice)"
        class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
        role="menuitem" tabindex="-1" id="menu-item-0">
        <svg [ngClass]="{'animate-spin': invoice.pushing}" class="mr-3 h-5 w-5 text-main-primary"
            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
        </svg>
        Push To
    </a>
    </ng-container>
    <ng-container *ngIf="source === 'customer'">
        <a *ngIf="customer.status !== 'pending'" href="javascript:void(0)" (click)="pullFrom.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <!-- [ngClass]="{'animate-spin': customer.pulling}" -->
            <svg class="mr-3 h-5 w-5 text-main-primary"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Pull From
        </a>
        <a href="javascript:void(0)" (click)="pushTo.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <!-- [ngClass]="{'animate-spin': customer.pushing}" -->
            <svg class="mr-3 h-5 w-5 text-main-primary"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Push To
        </a>
    </ng-container>
    <ng-container *ngIf="source === 'service'">
        <a *ngIf="service.status !== 'pending'" href="javascript:void(0)" (click)="pullFrom.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg class="mr-3 h-5 w-5 text-main-primary"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Pull From
        </a>
        <a href="javascript:void(0)" (click)="pushTo.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg class="mr-3 h-5 w-5 text-main-primary"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Push To
        </a>
    </ng-container>
    <ng-container *ngIf="source === 'vendor'">
        <a *ngIf="vendor.status !== 'pending'" href="javascript:void(0)" (click)="pullFrom.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg class="mr-3 h-5 w-5 text-main-primary"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Pull From
        </a>
        <a href="javascript:void(0)" (click)="pushTo.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg class="mr-3 h-5 w-5 text-main-primary"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Push To
        </a>
    </ng-container>
    <ng-container *ngIf="source === 'bill'">
        <a *ngIf="bill?.Id" href="javascript:void(0)" (click)="send.emit(bill)"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1">
            <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 h-5 w-5 text-main-primary" viewBox="0 0 24 24">
                <path fill="currentColor"
                    d="M1.946 9.315c-.522-.174-.527-.455.01-.634L21.044 2.32c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8l-8 6z" />
            </svg>
            Send
        </a>
    <a *ngIf="canPay" href="javascript:void(0)" (click)="pay.emit(bill)"
        class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
        role="menuitem" tabindex="-1" id="menu-item-0">
        <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 h-5 w-5 text-main-primary" fill="none" viewBox="0 0 24 24"
            stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
                d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Z" />
        </svg>
        Pay
    </a>
    <a href="javascript:void(0)" (click)="delete.emit(bill)"
        class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
        role="menuitem" tabindex="-1" id="menu-item-0">
        <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 h-5 w-5 text-main-primary"
            viewBox="0 0 24 24">
            <path fill="currentColor"
                d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2zM7 6v13z" />
        </svg>
        Delete
    </a>
    <a href="javascript:void(0)" (click)="detail.emit(bill)"
        class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
        role="menuitem" tabindex="-1" id="menu-item-0">
        <svg class="mr-3 h-5 w-5 text-main-primary" fill="currentColor" viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M12 15a3 3 0 100-6 3 3 0 000 6z"></path>
            <path clip-rule="evenodd" d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185
                                                                        3.223 10.675 7.69.12.362.12.752 0 1.113-1.487
                                                                        4.471-5.705 7.697-10.677 7.697-4.97
                                                                        0-9.186-3.223-10.675-7.69a1.762
                                                                        1.762 0 010-1.113zM17.25 12a5.25
                                                                        5.25 0 11-10.5 0 5.25 5.25 0
                                                                        0110.5 0z" fill-rule="evenodd">
            </path>
        </svg>
        Detail
    </a>
    <a *ngIf="bill.status !== 'pending'" href="javascript:void(0)" (click)="pullFrom.emit(bill)"
        class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
        role="menuitem" tabindex="-1" id="menu-item-0">
        <svg [ngClass]="{'animate-spin': bill.pulling}" class="mr-3 h-5 w-5 text-main-primary"
            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
        </svg>
        Pull From
    </a>
    <a href="javascript:void(0)" (click)="pushTo.emit(bill)"
        class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
        role="menuitem" tabindex="-1" id="menu-item-0">
        <svg [ngClass]="{'animate-spin': bill.pushing}" class="mr-3 h-5 w-5 text-main-primary"
            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
        </svg>
        Push To
    </a>
    </ng-container>
    <ng-container *ngIf="source === 'billPayment'">
        <a *ngIf="billPayment?.status !== 'pending'" href="javascript:void(0)" (click)="pullFrom.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg [ngClass]="{'animate-spin': billPayment?.pulling}" class="mr-3 h-5 w-5 text-main-primary"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Pull From
        </a>
        <a href="javascript:void(0)" (click)="pushTo.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg [ngClass]="{'animate-spin': billPayment?.pushing}" class="mr-3 h-5 w-5 text-main-primary"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Push To
        </a>
        <a *ngIf="billPayment?.Id" href="javascript:void(0)" (click)="voidPayment.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg class="mr-3 h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636" />
            </svg>
            Void
        </a>
        <a href="javascript:void(0)" (click)="deleteBillPayment.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg class="mr-3 h-5 w-5 cursor-pointer text-red-600/80" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
            </svg>
            Delete
        </a>
    </ng-container>
    <ng-container *ngIf="source === 'payment'">
        <a *ngIf="payment?.status !== 'pending'" href="javascript:void(0)" (click)="pullFrom.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg [ngClass]="{'animate-spin': payment?.pulling}" class="mr-3 h-5 w-5 text-main-primary"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Pull From
        </a>
        <a *ngIf="!payment?.Id" href="javascript:void(0)" (click)="pushTo.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg [ngClass]="{'animate-spin': payment?.pushing}" class="mr-3 h-5 w-5 text-main-primary"
                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
            </svg>
            Push To
        </a>
        <a *ngIf="payment?.Id" href="javascript:void(0)" (click)="voidPayment.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg class="mr-3 h-5 w-5 text-main-primary" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636" />
            </svg>
            Void
        </a>
        <a href="javascript:void(0)" (click)="deletePayment.emit()"
            class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center px-4 py-1 text-sm"
            role="menuitem" tabindex="-1" id="menu-item-0">
            <svg class="mr-3 h-5 w-5 cursor-pointer text-red-600/80" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
            </svg>
            Delete
        </a>
    </ng-container>
</div>